import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL

export function getLicenceList(suscription:any) {
  return axios.get(API_URL+'/v1/CTX-R/'+suscription+'/list')
}
export function getLicenseListglobal(suscription:any,tenant:number) {
  return axios.get(API_URL+'/v1/CTX-R/'+suscription+'/list?tenantId='+tenant)
}

export function getLicenseId(suscription:any,id:any) {
    return axios.get(API_URL+'/v1/CTX-R/'+suscription+'/'+id)
  }
export function getLicenseIdGlobal(suscription:any,id:any,tenant:number) {
    return axios.get(API_URL+'/v1/CTX-R/'+suscription+'/'+id+'?tenantId='+tenant)
  }
export function getroles() {
    return axios.get(API_URL+'/v1/rol/')
  }